import { type ExamEventStatus } from '@exam-center/graphql';
import { FilterButtonGroup } from '@shared/components';

const EXAM_EVENT_STATUS_OPTIONS = [
  { label: 'กำหนดการสอบ', value: 'SCHEDULED' },
  { label: 'เตรียมพร้อมสอบ', value: 'READY_TO_EXAM' },
  { label: 'กำลังสอบ', value: 'IN_PROGRESS' },
  { label: 'สอบเสร็จสิ้น', value: 'COMPLETED' },
  { label: 'ยกเลิกรอบสอบ', value: 'CANCELED' },
  { label: 'ทั้งหมด', value: 'ALL' },
];
interface ExamEventStatusSearchSelectionProps {
  value: ExamEventStatus | 'ALL';
  onChange: (value: ExamEventStatus | 'ALL') => void;
}

export default function ExamEventStatusButtonGroup(
  props: Readonly<ExamEventStatusSearchSelectionProps>,
) {
  const { value, onChange } = props;

  return (
    <FilterButtonGroup
      items={EXAM_EVENT_STATUS_OPTIONS}
      value={value}
      onChange={(value) => {
        onChange(value as ExamEventStatus);
      }}
    />
  );
}
